import React, { useEffect } from "react";
import FileInput from "../../../Components/FileInput/FileInput";
import Modal from "../../../Components/Modal/Modal";
import Select from "../../../Components/Select/Select";
import SmallCard from "../../../Components/SmallCard/SmallCard";
import avatar from "../../../images/Avatar_2.svg"
import Input from "../../../Components/Input/Input";
import { mimeTypes } from "../../../constants/constants";
import pdfIcon from "../../../icons/PdfIcon.svg"
import EmptyBlock from "../../../Components/EmptyBlock/EmptyBlock";

export default function AddUlSubjectModal({ ulSubject, isOpen, setOpen, documentTypes, documentTypeCode, setDocumentTypeCode, documentDate, setDocumentDate, document, setDocument, sig, setSig, onSave }) {


    return (
        <Modal onSave={() => onSave()} title={`Добавление участника (Юридическое лицо)`} isOpen={isOpen} setOpen={setOpen}>
            <label>Участник</label>
            <SmallCard
                title={ulSubject?.Name}
                subtitle={""}
                avatar={avatar}
            />
            <label>Основной представитель</label>
            {
                ulSubject?.Agents?.length == 0 &&
                <EmptyBlock title="Представители отсутвуют"></EmptyBlock>
            }
            {
                ulSubject?.Agents?.filter(x => x.IsMain).map((x) =>
                    <SmallCard
                        title={x.FioGenitive}
                        subtitle={""}
                        avatar={avatar}
                    />
                )
            }
            <label>Документ, подтверждающий полномочия</label>
            {
                !document &&
                <FileInput accept={[mimeTypes.Pdf, mimeTypes.Docx]} onChange={(value) => setDocument(value)} ></FileInput>

            }
            {
                document &&
                <SmallCard onRemove={() => setDocument(null)} avatar={pdfIcon} type="default" title={document.name}></SmallCard>
            }
            <label>Электронная подпись</label>
            {
                !sig &&
                <FileInput accept={[mimeTypes.Sig]} onChange={(value) => setSig(value)} ></FileInput>

            }
            {
                sig &&
                <SmallCard onRemove={() => setSig(null)} avatar={pdfIcon} type="default" title={sig.name}></SmallCard>

            }
            <Select value={documentTypeCode} onChange={setDocumentTypeCode} label="Тип документа">
                {documentTypes.map((x) =>
                    <option value={x.code}>{x.name}</option>
                )}
            </Select>
            <Input mask={Date} value={documentDate} onChange={(value) => setDocumentDate(value)} label="Дата выдачи"></Input>

        </Modal>
    )
}